import { Box, Grid2, Paper } from "@mui/material";
import * as React from "react";
import logosf from "../images/logoDLS.jpg";
import banner2 from "../images/Banner2.png";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import CardActionArea from "@mui/material/CardActionArea";
import image09 from "../images/image009.jpg";
import image08 from "../images/image008.jpg";
import image04 from "../images/image004.jpg";
import "animate.css";
import etsToefl from "../images/etstoefl.png";
import college from "../images/collegelogo.png";
import { Helmet } from "react-helmet-async";

const images = [logosf, etsToefl, college];

export default function Home() {
  const [currentIndex, setCurrentIndex] = React.useState(0);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000); // Cambia cada 3 segundos
    return () => clearInterval(interval);
  }, []);
  return (
    <>
      <Helmet>
        <title> DLS - Inicio</title>

        <meta
          name="description"
          content="Digital Language Services es un Centro de Idiomas con 22 años de experiencia en la enseñanza de inglés, incluyendo cursos de preparación para exámenes TOEFL iBT e IELTS."
        />
        <meta
          name="keywords"
          content="TOEFL, iBT, IELTS, idiomas, cursos, certificacion, La Paz, Cochabamba, Santa Cruz, traductor, traduccion"
        />
        <meta name="author" content="DLS" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

        <link rel="icon" href="/favicon.ico" />

        <meta property="og:type" content="website" />
        <meta property="og:title" content="Digital Language Services" />
        <meta
          property="og:description"
          content="Digital Language Services es un Centro de Idiomas con 22 años de experiencia en la enseñanza de inglés, incluyendo cursos de preparación para exámenes TOEFL iBT e IELTS."
        />
        <meta
          property="og:image"
          content="https://dls.com.bo/static/media/logo_DLS.6424b652d76d8584dbc3.png"
        />
        <meta property="og:url" content="https://dls.com.bo" />

        <link rel="canonical" href="https://dls.com.bo" />
      </Helmet>
      <Box
        sx={{
          width: "auto",
          display: "block",
        }}
      >
        <Box>
          <Grid2 container>
            <Grid2 size={{ xs: 12, sm: 12, md: 6 }}>
              <Box
                sx={{
                  background: "#009999",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={banner2}
                  alt="Digital Language Services"
                  className="animate__animated animate__fadeInLeft img-dim-banner"
                />
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 12, md: 6 }}>
              <Box
                sx={{
                  background: "#009999",
                  display: "flex",
                  width: "100%",
                  height: "100%",
                }}
              >
                <Box
                  sx={{
                    background: "#fff",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    height: "100%",
                    padding: "20px 0",
                    clipPath: {
                      xs: "none",
                      sm: "none",
                      md: "polygon(10% 0, 100% 0, 100% 100%, 0% 100%)",
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "block",
                      height: "100%",
                      width: "100%",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        fontWeight: "bold",
                        color: "#077f83",
                        padding: {
                          sx: "0",
                          sm: "0",
                          md: "0px 5px 0px 50px ",
                        },
                        justifyContent: "center",
                        textAlign: "center",
                        width: "100%",
                        fontSize: "calc(9px + 1vw)",
                      }}
                    >
                      TENEMOS RECONOCIMIENTO A NIVEL INTERNACIONAL
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        width: "100%",
                        height: {
                          xs: "100px",
                          sm: "130px",
                          md: "100%",
                        },
                        alignItems: "center",
                      }}
                    >
                      <Box className="sequential-carousel">
                        {images.map((image, index) => (
                          <img
                            key={index}
                            src={image}
                            alt={`Slide ${index + 1}`}
                            className={`carousel-image ${
                              currentIndex === index ? "visible" : "hidden"
                            }`}
                          />
                        ))}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid2>
          </Grid2>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",

            padding: "2px 0",
          }}
        >
          <Box
            sx={{
              maxWidth: {
                xs: "100vw",
                sm: "90vw",
                md: "70vw",
              },
              display: "block",
              padding: "2px",
              textAlign: "justify",
            }}
          >
            <Box p={3}>
              <Box>
                <Box
                  sx={{
                    display: "block",
                    textAlign: "center",
                    padding: "25px",
                  }}
                ></Box>
              </Box>
              <Paper>
                <Grid2 container spacing={2}>
                  <Grid2 size={{ xs: 12, sm: 12, md: 8, lg: 8 }}>
                    <Box sx={{ paddingRight: "10px" }}>
                      <Typography variant="h5" p={2}>
                        <b>¿Quienes Somos?</b>
                      </Typography>
                      <Typography variant="body1">
                        <ul>
                          <li>
                            DLS (Digital Language Services) es un Centro de
                            Idiomas con 22 años de experiencia en la enseñanza
                            de inglés, incluyendo cursos generales y preparación
                            para exámenes como TOEFL iBT e IELTS. Desde 2009,
                            está certificado por ETS para administrar el TOEFL
                            iBT, y sus cursos incluyen certificación oficial de
                            ETS y TOEFL iBT.
                          </li>
                          <br />
                          <li>
                            Tambien no satisface ser un instituto especializado
                            en capacitación ejecutiva y empresarial, con
                            clientes destacados como: ChildFund, PNUD,
                            DELEGACIÓN DE LA UNIÓN EUROPEA, CANCILLERIA DE LA
                            REPUBLICA, CORTE SUPREMA DE JUSTICIA, ASFI, SOBOCE
                            S.A., BOA, AMASZONAS, TELEFERICOS, DOPPELMAYR,
                            NUEVATEL PCS, VICEMINISTERIO DE INVERSIÓN PUBLICA Y
                            FINANCIAMENTO EXTERNO, MINISTERIO DE MEDIO AMBIENTE,
                            BANCO CENTRAL DE BOLIVIA, entre otros.
                          </li>
                        </ul>
                      </Typography>
                    </Box>
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        textAlign: "center",
                        alignItems: "center",
                        height: "100%",
                      }}
                    >
                      <img
                        className="img-dim-about"
                        src={image09}
                        alt="Digital Language Services"
                      />{" "}
                    </Box>
                  </Grid2>
                </Grid2>
              </Paper>
            </Box>

            <Grid2 container spacing={2}>
              <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
                <Box p={3}>
                  <Card>
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        height="250"
                        image={image08}
                        alt="toefl"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                          Nuestra visión y enfoque pedagógico
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{ color: "text.secondary" }}
                        >
                          Es el de guiar y apoyar a nuestros estudiantes
                          proporcionándoles todas las herramientas del idioma
                          inglés para mejorar y desarrollar sus competencias.
                          <br /> <b> Nuestro enfoque pedagógico</b> es
                          innovadora en comparación a otros institutos de
                          enseñanza del idioma Inglés de nuestro país;
                          respaldados por nuestra trayectoria y experiencia,
                          ofrecemos un método con contenidos acordes a las
                          necesidades específicas de los participantes.
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Box>
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
                <Box p={3}>
                  <Card>
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        height="250"
                        image={image04}
                        alt="green iguana"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                          Nuestra Misión
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{ color: "text.secondary" }}
                        >
                          Proporcionar la más alta calidad de enseñanza basada
                          en el postulado de la "capacitación personalizada",
                          acorde a las necesidades específicas de cada
                          estudiante.
                          <br /> Lograr a la conclusión de nuestro programa de
                          estudios que cada estudiante pueda interactuar de
                          manera efectiva (escrita y oralmente) y así poder
                          mejorar su desempeño académico o laboral.
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Box>
              </Grid2>
            </Grid2>
          </Box>
        </Box>
      </Box>
    </>
  );
}
